<template>
  <div class='cve-version-table-cell'>
    <v-chip
      x-small
      label
      outlined
      text-color="black"
      class='chip'
    >
      {{ version }}
    </v-chip>
  </div>
</template>

<script>

export default {
  name: 'CveVersionTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    version() {
      return this.item[this.column.field] || false;
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/styles/design-system';

.cve-version-table-cell {
  .v-slide-group__wrapper {
    padding-left: 0;
    background-color: transparent !important;
  }

  .v-slide-group {
    margin-right: rem(20);
    height: 100%;
    padding: $space-4;
  }

  .v-slide-group__content {
    flex-wrap: wrap;
  }

  .v-slide-group__next,
  .v-slide-group__prev {
    min-width: 0;
  }
}
</style>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.cve-version-table-cell {
  display: flex;
  align-items: center;
  z-index: 3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: rem(100);
  color: var(--text-primary);
  font-family: $font-family-regular;
  font-size: $font-size-base;
  letter-spacing: 0;
  line-height: rem(17);
  border-radius: $radius-md;
}
</style>
